<template>
  <div>
    <!-- Start Breadcrumbs -->
    <div class="breadcrumbs">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="breadcrumbs-content">
              <h1 class="page-title">Product Details</h1>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12">
            <ul class="breadcrumb-nav">
              <li><router-link to="/">Home</router-link></li>
              <li>Product Details</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- End Breadcrumbs -->

    <!-- Start Item Details -->

    <section class="item-details section">
      <div class="container">
        <div class="top-area">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="product-images">
                <main id="gallery">
                  <div class="main-img">
                    <img :src="product.imgUrl" id="current" alt="Product Image" />
                  </div>
                </main>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <div class="product-info">
                <h2 class="title">{{ product.name }}</h2>
                <br />
                <h3 class="price">{{ product.price }}</h3>
                <div class="list-info">
                  <h4>Informations</h4>
                  <ul>
                    <li><span>Category:</span> {{ product.Category.name }}</li>
                    <li><span>Created At:</span> {{ product.createdAt }}</li>
                  </ul>
                </div>
                <div class="contact-info">
                  <ul>
                    <li>
                      <div class="button">
                        <a
                          href=""
                          class="btn"
                          @click.prevent="addToFavorites(product.id)"
                          ><i class="lni lni-heart"></i> Add To Favorites</a
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item-details-blocks">
          <div class="row">
            <div class="col-lg-8 col-md-7 col-12">
              <!-- Start Single Block -->
              <div class="single-block description">
                <h3>Description</h3>
                <p>
                  {{ product.description }}
                </p>
              </div>
              <!-- End Single Block -->
            </div>
            <div class="col-lg-4 col-md-5 col-12">
              <div class="item-details-sidebar">
                <!-- Start Single Block -->
                <div class="single-block">
                  <h3>Share QR Code</h3>
                  <img class="card-img-top" :src="qrCode" alt="Product Image" />
                </div>
                <!-- End Single Block -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Item Details -->
  </div>
</template>

<script>
export default {
  name: "DetailPage",
  methods: {
    addToFavorites(productId) {
      this.$store
        .dispatch("addToFavorites", productId)
        .then(({ data }) => {
          this.$router.push("/favorites").catch(()=>{})
          this.$swal.fire({
            position: "top-end",
            icon: "success",
            title: data.message,
            text: data.email,
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message,
            showCloseButton: true,
            showConfirmButton: false,
          });
        });
    },
  },
  computed: {
    product() {
      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      };
      let formattedProduct = this.$store.state.viewedProduct;
      formattedProduct.price = Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
      }).format(formattedProduct.price);
      formattedProduct.createdAt = new Date(
        formattedProduct.createdAt
      ).toLocaleDateString("en-US", options);
      return formattedProduct;
    },
    qrCode() {
      return this.$store.state.viewedQrCode;
    },
  },
  created() {
    this.$store
      .dispatch("fetchSingleProduct", { id: this.$route.params.id })
      .then(({ data }) => {
        this.$store.commit("SET_VIEWED_PRODUCT", data);
      })
      .catch((err) => {
        this.$router.push('/')
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response.data.message,
          showCloseButton: true,
          showConfirmButton: false,
        });
      });
    this.$store.dispatch("getQrCode", { data: this.$route.path });
  },
};
</script>

<style>
</style>